<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px; font-size: small;">
      <div class="card">
        <div class="card-header bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title">Detalle de Solicitud #{{ solicitud.id }}</h5>
            <p>Estado: </p>
            <p>
                <BBadge :variant="getBadgeVariant(solicitud.estado_solicitud)">
                    solicitud: {{ solicitud.estado_solicitud }}
                </BBadge>
            </p>
            <p>
                <BBadge :variant="getBadgeVariant(solicitud.estado_autorizacion)">
                    Autorizacion: {{ solicitud.estado_autorizacion?solicitud.estado_autorizacion:'pendiente' }}
                </BBadge>
            </p>
            <p>
                <span v-if="solicitud.fecha_despacho" class="ms-2">
                    Despachado el: {{ formatDate(solicitud.fecha_despacho) }}
                </span>
            </p>
            <div>
              <BButton
                v-if="solicitud.estado_solicitud!='pendiente' "
                variant="info"
                class="btn btn-sm"
                @click="generateNotaPDF(solicitud.id)"
              >
                <i class="fa fa-file-pdf me-1"></i> Nota Solicitud
              </BButton>
              <BButton
              v-if="solicitud.estado_autorizacion=='aprobada'"
                variant="success"
                class="btn btn-sm"
                @click="generateActaSalida(solicitud.id)"
              >
                <i class="fa fa-file-pdf me-1"></i> Acta Salida
              </BButton>
              <BButton
                variant="success"
                size="sm"
                @click="solicitar(solicitud.id)"
                v-if="solicitud.estado_solicitud === 'pendiente'">
                <i class="fa fa-check me-1"></i> Solicitar
              </BButton>
              <BButton @click="router.go(-1)" variant="secondary" size="sm">
                <i class="fa fa-arrow-left me-1"></i> Volver
              </BButton>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row md-4">
            <div class="col-md-8">
              <div class="row mb-4">
                <div class="col-md-12">
                  <p><strong>Fecha:</strong> {{ formatDate(solicitud.fecha_solicitud) }}</p>
                  <p><strong>Detalle:</strong> {{ solicitud.detalle_solicitud }}</p>
                  <p><strong>Unidad:</strong> {{ solicitud.unidad.nombre_unidad }}</p>
                  <p><strong>Solicitante:</strong> {{ solicitud.nombres}} {{ solicitud.paterno }} {{solicitud.materno }}</p>
                  <p v-if="solicitud.observacion"><strong>Observación:</strong> {{ solicitud.observacion }}</p>
                  <p v-if="solicitud.costo_total > 0"><strong>Costo Total:</strong> {{ solicitud.costo_total }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <!-- Sección de autorización para administradores  hasPermission('autorizar_solicitudes') && -->
              <div class="row mt-0" v-if="solicitud.estado_solicitud === 'solicitada' && hasPermission('autorizar_solicitudes')">
                <div class="col-md-12">
                  <div class="card border-primary">
                    <div class="card-header bg-primary text-white">
                      <h6 class="mb-0">Autorización</h6>
                    </div>
                    <div class="card-body">
                      <div class="d-flex justify-content-center gap-3">
                        <BButton
                          @click="showAprobarModal"
                          variant="success"
                          class="px-4"
                        >
                          <i class="fa fa-check me-2"></i> Aprobar
                        </BButton>
                        <BButton
                          @click="showRechazarModal"
                          variant="danger"
                          class="px-4"
                        >
                          <i class="fa fa-times me-2"></i> Rechazar
                        </BButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Sección para generar nota de salida   -->
              <div class="row mt-0" v-if="hasPermission('despachar_solicitudes') && solicitud.estado_autorizacion === 'aprobada' && !solicitud.fecha_despacho">
                <div class="col-md-12">
                  <div class="card border-warning">
                    <div class="card-header bg-warning text-dark">
                      <h6 class="mb-0">Despacho</h6>
                    </div>
                    <div class="card-body text-center">
                      <BButton
                        @click="despacharSolicitud"
                        variant="warning"
                        class="px-4"
                      >
                        <i class="fa fa-truck me-2"></i> Despachar Solicitud
                      </BButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5>Items Solicitados</h5>
                <div>
                  <BButton
                    v-if="solicitud.estado_solicitud === 'pendiente' && hasPermission('salida_create') && !isEditing"
                    @click="startEditing"
                    variant="primary"
                    size="sm"
                    class="me-2"
                  >
                    <i class="fa fa-edit me-1"></i> Editar
                  </BButton>
                  <BButton
                    v-if="hasPermission('despachar_solicitudes') && solicitud.estado_autorizacion === 'aprobada' && !solicitud.fecha_despacho"
                    @click="startEditing"
                    variant="primary"
                    size="sm"
                    class="me-2"
                  >
                    <i class="fa fa-edit me-1"></i> Editar
                  </BButton>

                  <BButton
                    v-if="solicitud.estado_solicitud === 'pendiente' && isEditing"
                    @click="addNewRow"
                    variant="success"
                    size="sm"
                  >
                    <i class="fa fa-plus me-1"></i> Agregar Item
                  </BButton>
                </div>
              </div>

              <div v-if="loading" class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </div>

              <template v-else>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered table-fixed-layout">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Cantidad</th>
                        <th>Unidad</th>
                        <th>Stock</th>
                        <!-- Columnas adicionales para partida 25600 -->
                        <th v-if="hasPartida25600Items">de - a</th>
                        <th v-if="hasPartida25600Items">Serie</th>
                        <th v-if="hasPartida25600Items">Origen</th>
                        <th v-if="isEditing">.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index">
                        <td style=" height: 50px; ">
                          <!-- Selector de item en edición con autocomplete -->
                          <div v-if="isEditing" class="d-flex flex-column gap-1">
                            <select
                              v-model="item.id_categoria"
                              class="form-select form-select-sm mb-1"
                              @change="loadItemsByCategoria(index)"
                              :disabled="solicitud.estado_solicitud !== 'pendiente'"
                            >
                              <option value="">Seleccione categoría</option>
                              <option
                                v-for="cat in categorias"
                                :key="cat.id"
                                :value="cat.id"
                              >
                                {{ cat.id_partida }}: {{ cat.nombre_categoria }}
                              </option>
                            </select>

                            <!-- Campo de búsqueda con autocomplete -->
                            <div class="position-relative" v-if="item.id_categoria" style="min-height: 38px;">
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                :class="{ 'is-invalid': errors[`items.${index}.id_item`] }"
                                v-model="item.searchText"
                                placeholder="Buscar por código o nombre..."
                                @input="onItemSearch(index, $event)"
                                @focus="onItemFocus(index)"
                                @blur="hideSuggestions(index)"
                                @keydown.down.prevent="selectNextSuggestion(index)"
                                @keydown.up.prevent="selectPrevSuggestion(index)"
                                @keydown.enter.prevent="applySelectedSuggestion(index)"
                                autocomplete="off"
                                :disabled="solicitud.estado_solicitud !== 'pendiente'"
                                style="padding-right: 30px;"
                              />
                              <i class="fa fa-search position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%); color: #6c757d; font-size: 14px; pointer-events: none;"></i>

                              <!-- Lista de sugerencias -->
                              <div
                                v-if="item.showSuggestions && item.filteredItems && item.filteredItems.length > 0"
                                class="suggestions-list"
                              >
                                <div
                                  v-for="(sugItem, sugIndex) in item.filteredItems"
                                  :key="sugItem.id"
                                  class="suggestion-item"
                                  :class="{ active: item.selectedSuggestionIndex === sugIndex }"
                                  @mousedown.prevent="selectSuggestion(index, sugItem)"
                                  @mouseenter="item.selectedSuggestionIndex = sugIndex"
                                >
                                  <div class="d-flex align-items-center justify-content-between">
                                    <div>
                                      <span><strong>{{ sugItem.codigo }}</strong> - {{ sugItem.nombre_item }}</span>
                                      <small class="text-muted ms-2">({{ sugItem.unidad_medida || 'N/A' }})</small>
                                    </div>
                                    <div>
                                      <span v-if="sugItem.stock_disponible <= 0" class="badge bg-danger">Sin stock</span>
                                      <span v-else class="badge bg-success">Stock: {{ sugItem.stock_disponible }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-else-if="item.showSuggestions && item.searchText && item.searchText.length > 1 && (!item.filteredItems || item.filteredItems.length === 0)"
                                class="suggestions-list"
                              >
                                <div class="suggestion-item text-muted text-center py-2">
                                  <i class="fa fa-exclamation-circle me-2"></i>
                                  No se encontraron ítems con "{{ item.searchText }}"
                                </div>
                              </div>
                            </div>
                            <small v-if="!item.id_categoria" class="text-muted">Seleccione una categoría primero</small>
                          </div>
                          <!-- Visualización en modo lectura -->
                          <span v-else>
                            {{ item.item_codigo }} : {{ item.item_name }}
                            <span v-if="item.needsAdditionalFields" class="badge bg-info ms-1 partida-badge">25600</span>
                          </span>
                        </td>
                        <td>
                          <!-- Input de cantidad en edición -->
                          <input
                            v-if="isEditing"
                            type="number"
                            v-model.number="item.cantidad"
                            min="1"
                            :max="getStockDisponible(item.id_item)"
                            class="form-control form-control-sm"
                            :disabled="(!item.id_item || solicitud.estado_solicitud !== 'pendiente') && (!hasPermission('despachar_solicitudes') && solicitud.fecha_despacho)"
                            @input="validateCantidad(index)"
                            @blur="validateCantidad(index)"
                          >
                          <!-- Visualización en modo lectura -->
                          <span v-else>
                            {{ item.cantidad }}
                          </span>
                        </td>
                        <td>
                          {{ getItemUnidad(item.id_item) }}
                        </td>
                        <td>
                          <template v-if="canViewFullStock">
                            {{ getStockDisponible(item.id_item) }}
                          </template>
                          <template v-else>
                            <span :class="{'text-success': getStockDisponible(item.id_item) > 0, 'text-danger': getStockDisponible(item.id_item) <= 0}">
                              {{ getStockDisponible(item.id_item) > 0 ? 'Con stock' : 'Sin stock' }}
                            </span>
                          </template>
                        </td>
                        <!-- Campos adicionales para partida 25600 -->
                        <td v-if="hasPartida25600Items">
                          <span :class="{'text-muted': !item.needsAdditionalFields}">
                            {{ item.needsAdditionalFields ? item.de_nro : '-' }}
                          </span> -
                          <span :class="{'text-muted': !item.needsAdditionalFields}">
                            {{ item.needsAdditionalFields ? item.a_nro : '-' }}
                          </span>
                        </td>
                        <td v-if="hasPartida25600Items">
                          <span :class="{'text-muted': !item.needsAdditionalFields}">
                            {{ item.needsAdditionalFields ? item.serie : '-' }}
                          </span>
                        </td>
                        <td v-if="hasPartida25600Items">
                          <span :class="{'text-muted': !item.needsAdditionalFields}">
                            {{ item.needsAdditionalFields ? (item.origen == 2 ? 'DDE' : item.origen) : '-' }}
                          </span>
                        </td>
                        <td v-if="isEditing">
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            @click="removeItem(index)"
                            :disabled="items.length <= 1 || solicitud.estado_solicitud !== 'pendiente'"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="items.length === 0 && !isEditing">
                        <td :colspan="hasPartida25600Items ? 8 : 4" class="text-center text-muted py-3">
                          No hay items agregados a esta solicitud
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="errors.items" class="alert alert-danger">
                  {{ errors.items[0] }}
                </div>

                <div class="d-flex justify-content-end mt-3" v-if="isEditing">
                  <BButton
                    type="button"
                    variant="secondary"
                    @click="cancelEdit"
                    class="me-2"
                  >
                    Cancelar
                  </BButton>
                  <BButton
                    type="button"
                    variant="primary"
                    @click="saveItems"
                    :disabled="loadingForm"
                  >
                    <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status"></span>
                    Guardar Cambios
                  </BButton>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modales de aprobación/rechazo -->
    <BModal
      v-model="aprobarModalVisible"
      title="Aprobar Solicitud"
      size="md"
      centered
      hide-footer
    >
      <form @submit.prevent="aprobarSolicitud">
        <div class="form-group">
          <label class="form-label">Observación (Opcional)</label>
          <textarea
            v-model="aprobarForm.observacion"
            class="form-control"
            rows="3"
          ></textarea>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="aprobarModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="success"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status"></span>
            Aprobar
          </BButton>
        </div>
      </form>
    </BModal>

    <BModal
      v-model="rechazarModalVisible"
      title="Rechazar Solicitud"
      size="md"
      centered
      hide-footer
    >
      <form @submit.prevent="rechazarSolicitud">
        <div class="form-group">
          <label class="form-label">Motivo del rechazo</label>
          <textarea
            v-model="rechazarForm.observacion"
            class="form-control"
            rows="3"
            required
          ></textarea>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="rechazarModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="danger"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status"></span>
            Rechazar
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge } from 'bootstrap-vue-3';

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

// Datos reactivos
const solicitud = ref({
  id: null,
  unidad: {},
  detalles: []
});
const categorias = ref([]);
const itemsPorCategoria = ref({});
const itemsDisponibles = ref([]);
const items = ref([]);
const loading = ref(true);
const loadingForm = ref(false);
const isEditing = ref(false);
const errors = ref({});

// Modales
const aprobarModalVisible = ref(false);
const rechazarModalVisible = ref(false);

// Formularios
const aprobarForm = ref({ observacion: '' });
const rechazarForm = ref({ observacion: '' });

// Computed properties
const hasPermission = (permission) => {
  return authStore.user?.permissions?.includes(permission);
};
// Computed para obtener los roles del usuario
const userRoles = computed(() => {
  const roles = authStore.user?.roles || [];
  return roles; // Retornamos el array completo para mejor manejo
});
// Computed para verificar si el usuario puede ver el stock completo
const canViewFullStock = computed(() => {
  const roles = userRoles.value;
  // Si tiene permisos de autorización o despacho, puede ver el stock completo
  if (hasPermission('autorizar_solicitudes') || hasPermission('despachar_solicitudes')) {
    return true;
  }

  // Verificar si tiene roles de unidad o área (restringidos)
  // Convertimos los roles a string para comparación
  const userRoleNames = roles.map(role => role.name?.toLowerCase() || role.toLowerCase());

  // Roles que NO pueden ver el stock completo
  const restrictedRoles = ['unidad', 'area'];

  // Si tiene algún rol restringido, no puede ver el stock completo
  const hasRestrictedRole = userRoleNames.some(role =>
    restrictedRoles.some(restricted => role.includes(restricted))
  );

  return !hasRestrictedRole;
});

// Computed property para verificar si hay items de partida 25600
const hasPartida25600Items = computed(() => {
  return items.value.some(item => item.needsAdditionalFields);
});

const getItemsByCategoria = (id_categoria) => {
  if (!id_categoria) return [];

  // Asegurar que id_categoria sea string o número según como viene
  const categoriaId = id_categoria.toString();

  // Obtener items de esa categoría del objeto agrupado
  return itemsPorCategoria.value[categoriaId] || [];
};

// ==================== MÉTODOS DE AUTCOMPLETE ====================
const initItemSearch = (item) => {
  if (!item.searchText) {
    item.searchText = '';
  }
  if (!item.filteredItems) {
    item.filteredItems = [];
  }
  if (!item.showSuggestions) {
    item.showSuggestions = false;
  }
  if (item.selectedSuggestionIndex === undefined) {
    item.selectedSuggestionIndex = -1;
  }
};

const onItemSearch = (index, event) => {
  const item = items.value[index];
  const search = event.target.value.toLowerCase().trim();
  item.selectedSuggestionIndex = -1;

  // Obtener items de la categoría seleccionada
  const categoryItems = getItemsByCategoria(item.id_categoria);

  if (!search || search.length < 1) {
    item.filteredItems = categoryItems.slice(0, 20);
    item.showSuggestions = true;
    return;
  }

  item.filteredItems = categoryItems.filter(catItem =>
    catItem.codigo.toLowerCase().includes(search) ||
    catItem.nombre_item.toLowerCase().includes(search)
  ).slice(0, 50);

  item.showSuggestions = true;
};

const onItemFocus = (index) => {
  const item = items.value[index];
  if (!item.id_categoria) return;

  item.showSuggestions = true;
  if (!item.filteredItems || item.filteredItems.length === 0) {
    item.filteredItems = getItemsByCategoria(item.id_categoria).slice(0, 20);
  }
};

const hideSuggestions = (index) => {
  setTimeout(() => {
    const item = items.value[index];
    if (item) {
      item.showSuggestions = false;
    }
  }, 200);
};

const selectNextSuggestion = (index) => {
  const item = items.value[index];
  if (item.filteredItems && item.selectedSuggestionIndex < item.filteredItems.length - 1) {
    item.selectedSuggestionIndex++;
  }
};

const selectPrevSuggestion = (index) => {
  const item = items.value[index];
  if (item.selectedSuggestionIndex > 0) {
    item.selectedSuggestionIndex--;
  }
};

const applySelectedSuggestion = (index) => {
  const item = items.value[index];
  if (item.selectedSuggestionIndex >= 0 && item.filteredItems && item.selectedSuggestionIndex < item.filteredItems.length) {
    selectSuggestion(index, item.filteredItems[item.selectedSuggestionIndex]);
  }
};

const selectSuggestion = (index, selectedItem) => {
  const item = items.value[index];
  item.id_item = selectedItem.id;
  item.searchText = `${selectedItem.codigo} - ${selectedItem.nombre_item}`;
  item.showSuggestions = false;
  item.selectedSuggestionIndex = -1;

  // Actualizar información del item
  updateItemInfo(index);
};

// ==================== MÉTODOS PRINCIPALES ====================
const fetchSolicitud = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/salidas/${route.params.id}/ver`);
    solicitud.value = response.data.data;
    items.value = [...response.data.data.detalles.map(detalle => ({
      id_categoria: detalle.item?.id_categoria || '',
      id_item: detalle.id_item,
      cantidad: detalle.cantidad,
      de_nro: detalle.de_nro,
      a_nro: detalle.a_nro,
      serie: detalle.serie,
      origen: detalle.origen,
      id_lote: detalle.id_lote,
      needsAdditionalFields: detalle.de_nro !== null, // Asumimos que si tiene de_nro es partida 25600
      item_name: detalle.item?.nombre_item || '',
      item_codigo: detalle.item?.codigo || '',
      // Propiedades para autocomplete
      searchText: detalle.item ? `${detalle.item.codigo} - ${detalle.item.nombre_item}` : '',
      filteredItems: [],
      showSuggestions: false,
      selectedSuggestionIndex: -1
    }))];
  } catch (error) {
    Swal.fire('Error', 'No se pudo cargar la solicitud', 'error');
    router.push({ name: 'salidas' });
  } finally {
    loading.value = false;
  }
};

const fetchCategorias = async () => {
  try {
    const response = await axios.get('/compras/categorias');
    categorias.value = response.data.data;
  } catch (error) {
    console.error('Error al cargar categorías:', error);
    Swal.fire('Error', 'No se pudieron cargar las categorías', 'error');
  }
};

const fetchItemsDisponibles = async () => {
  try {
    const response = await axios.get('/salidas/items/stock-by-categoria');

    // La API devuelve data (lista plana) y agrupados (objeto por categoría)
    // Usamos agrupados para filtrar por categoría
    itemsPorCategoria.value = response.data.agrupados || {};

    console.log('Items agrupados por categoría:', itemsPorCategoria.value);

  } catch (error) {
    console.error('Error al cargar items:', error);
    Swal.fire('Error', 'No se pudieron cargar los items disponibles', 'error');
  }
};

const loadItemsByCategoria = (index) => {
  const item = items.value[index];
  // Resetear item seleccionado cuando cambia la categoría
  item.id_item = '';
  item.item_name = '';
  item.needsAdditionalFields = false;
  item.de_nro = null;
  item.a_nro = null;
  item.serie = '';
  item.origen = '';
  item.id_lote = null;
  item.searchText = '';
  item.filteredItems = [];
  item.showSuggestions = false;
  item.selectedSuggestionIndex = -1;
};

const getStockDisponible = (id_item) => {
  if (!id_item) return 0;

  // Buscar en todos los items agrupados
  let stock = 0;
  Object.values(itemsPorCategoria.value).forEach(itemsArray => {
    const found = itemsArray.find(i => i.id === id_item);
    if (found) {
      stock = found.stock_disponible;
    }
  });
  return stock;
};

const getItemNombre = (id_item) => {
  if (!id_item) return '';

  let nombre = '';
  Object.values(itemsPorCategoria.value).forEach(itemsArray => {
    const found = itemsArray.find(i => i.id === id_item);
    if (found) {
      nombre = found.nombre_item || '';
    }
  });
  return nombre;
};

const getItemUnidad = (id_item) => {
  if (!id_item) return '-';

  let unidad = '-';
  Object.values(itemsPorCategoria.value).forEach(itemsArray => {
    const found = itemsArray.find(i => i.id === id_item);
    if (found) {
      unidad = found.unidad_medida || '-';
    }
  });
  return unidad;
};

const isItemAlreadyAdded = (itemId, currentIndex) => {
  return items.value.some((item, index) =>
    index !== currentIndex && item.id_item === itemId
  );
};

const startEditing = () => {
  isEditing.value = true;
  // Si no hay items, agregar una fila vacía
  if (items.value.length === 0) {
    addNewRow();
  } else {
    // Asegurar que cada item tenga el campo id_categoria
    items.value.forEach(item => {
      if (!item.id_categoria && item.id_item) {
        const itemInfo = itemsDisponibles.value.find(i => i.id === item.id_item);
        if (itemInfo) {
          item.id_categoria = itemInfo.id_categoria;
        }
      }
      // Inicializar propiedades de autocomplete
      initItemSearch(item);
      // Si tiene id_item, mostrar el nombre en el campo de búsqueda
      if (item.id_item && !item.searchText) {
        const foundItem = getItemInfo(item.id_item);
        if (foundItem) {
          item.searchText = `${foundItem.codigo} - ${foundItem.nombre_item}`;
        }
      }
    });
  }
};

const getItemInfo = (id_item) => {
  if (!id_item) return null;
  let found = null;
  Object.values(itemsPorCategoria.value).forEach(itemsArray => {
    const item = itemsArray.find(i => i.id === id_item);
    if (item) found = item;
  });
  return found;
};

const addNewRow = () => {
  items.value.push({
    id_categoria: '',
    id_item: '',
    cantidad: 1,
    de_nro: null,
    a_nro: null,
    serie: '',
    origen: '',
    id_lote: null,
    needsAdditionalFields: false,
    item_name: '',
    searchText: '',
    filteredItems: [],
    showSuggestions: false,
    selectedSuggestionIndex: -1
  });
};

const removeItem = (index) => {
  if (items.value.length > 1) {
    items.value.splice(index, 1);
  } else {
    // Si es el último item, resetearlo en lugar de eliminarlo
    items.value[0] = {
      id_categoria: '',
      id_item: '',
      cantidad: 1,
      de_nro: null,
      a_nro: null,
      serie: '',
      origen: '',
      id_lote: null,
      needsAdditionalFields: false,
      item_name: '',
      searchText: '',
      filteredItems: [],
      showSuggestions: false,
      selectedSuggestionIndex: -1
    };
  }
};

const cancelEdit = () => {
  isEditing.value = false;
  fetchSolicitud(); // Recargar los datos originales
};

const saveItems = async () => {
  loadingForm.value = true;
  errors.value = {};

  try {
    // Filtrar items válidos (con id_item seleccionado)
    const validItems = items.value.filter(item => item.id_item);

    if (validItems.length === 0) {
      Swal.fire('Error', 'Debe agregar al menos un item válido', 'error');
      loadingForm.value = false;
      return;
    }

    const response = await axios.post(`/salidas/${solicitud.value.id}/items/save`, {
      items: validItems
    });

    Swal.fire('Éxito', response.data.message, 'success');
    isEditing.value = false;
    fetchSolicitud();
  } catch (error) {
    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
    } else {
      Swal.fire('Error', error.response?.data?.message || 'Error al guardar', 'error');
    }
  } finally {
    loadingForm.value = false;
  }
};

// Método para actualizar información cuando cambia el item
const updateItemInfo = async (index) => {
  const item = items.value[index];
  if (item.id_item) {
    try {
      // Verificar si es partida 25600
      const response = await axios.get(`/items/${item.id_item}/partida_sol`);
      const isPartida25600 = response.data.partida_presupuestaria === '25600';

      // Actualizar flags
      item.needsAdditionalFields = isPartida25600;
      item.item_name = getItemNombre(item.id_item);

      // Obtener código del item para mostrarlo
      const itemInfo = getItemInfo(item.id_item);
      if (itemInfo) {
        item.item_codigo = itemInfo.codigo;
      }

      // Obtener stock disponible
      const stockDisponible = getStockDisponible(item.id_item);

      // Si la cantidad actual excede el stock, ajustarla
      if (item.cantidad > stockDisponible) {
        item.cantidad = stockDisponible;
        Swal.fire('Aviso', `La cantidad ha sido ajustada al stock disponible: ${stockDisponible}`, 'info');
      }

      // Si es partida 25600, cargar información automáticamente
      if (isPartida25600 && item.cantidad > 0) {
        await updateItemNumbers(index);
      } else {
        // Limpiar campos si no es partida 25600
        item.de_nro = null;
        item.a_nro = null;
        item.serie = '';
        item.origen = '';
        item.id_lote = null;
      }
    } catch (error) {
      console.error('Error al actualizar información del item:', error);
    }
  } else {
    // Limpiar campos si no hay item seleccionado
    item.needsAdditionalFields = false;
    item.item_name = '';
    item.de_nro = null;
    item.a_nro = null;
    item.serie = '';
    item.origen = '';
    item.id_lote = null;
  }
};

// Método para actualizar números cuando cambia la cantidad
const updateItemNumbers = async (index) => {
  const item = items.value[index];
  // Validar que no exceda el stock disponible
  const stockDisponible = getStockDisponible(item.id_item);
  if (item.cantidad > stockDisponible) {
    item.cantidad = stockDisponible;
    Swal.fire('Error', `No puede exceder el stock disponible: ${stockDisponible}`, 'error');
    return;
  }
  if (item.needsAdditionalFields && item.id_item && item.cantidad > 0) {
    try {
      const response = await axios.get(`/items/${item.id_item}/lote-info`, {
        params: {
          cantidad: item.cantidad
        }
      });
      const loteInfo = response.data;
      // Validar que el rango esté disponible
      if (!loteInfo.success) {
        Swal.fire('Error', loteInfo.message, 'error');
        item.cantidad = 1; // Resetear a cantidad mínima
        return;
      }
      // Actualizar campos automáticamente
      item.de_nro = loteInfo.de_nro;
      item.a_nro = loteInfo.a_nro;
      item.serie = loteInfo.serie;
      item.origen = loteInfo.origen;
      item.id_lote = loteInfo.id_lote;
    } catch (error) {
      console.error('Error al actualizar números del item:', error);
      Swal.fire('Error', 'No se pudo actualizar la información del lote', 'error');
    }
  }
};

// Método para validar input de cantidad
const validateCantidad = (index) => {
  const item = items.value[index];
  if (!item.id_item) return;
  const stockDisponible = getStockDisponible(item.id_item);

  if (item.cantidad > stockDisponible) {
    item.cantidad = stockDisponible;
    Swal.fire('Error', `No puede exceder el stock disponible: ${stockDisponible}`, 'error');
  } else if (item.cantidad < 1) {
    item.cantidad = 1;
    Swal.fire('Error', 'La cantidad mínima es 1', 'error');
  }

  // Si es partida 25600, actualizar números
  if (item.needsAdditionalFields && item.cantidad > 0) {
    updateItemNumbers(index);
  }
};

const showAprobarModal = () => {
  aprobarForm.value = { observacion: '' };
  aprobarModalVisible.value = true;
};

const showRechazarModal = () => {
  rechazarForm.value = { observacion: '' };
  rechazarModalVisible.value = true;
};

const aprobarSolicitud = async () => {
  loadingForm.value = true;

  try {
    const response = await axios.post(`/salidas/${solicitud.value.id}/aprobar`, aprobarForm.value);
    Swal.fire('Éxito', response.data.message, 'success');
    aprobarModalVisible.value = false;
    fetchSolicitud();
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al aprobar', 'error');
  } finally {
    loadingForm.value = false;
  }
};

const rechazarSolicitud = async () => {
  loadingForm.value = true;

  try {
    const response = await axios.post(`/salidas/${solicitud.value.id}/rechazar`, rechazarForm.value);
    Swal.fire('Éxito', response.data.message, 'success');
    rechazarModalVisible.value = false;
    fetchSolicitud();
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al rechazar', 'error');
  } finally {
    loadingForm.value = false;
  }
};

const despacharSolicitud = async () => {
  try {
    const { isConfirmed } = await Swal.fire({
      title: 'Confirmar Despacho',
      text: '¿Está seguro de despachar esta solicitud?',
      icon: 'question',
      showCancelButton: true
    });

    if (isConfirmed) {
      const response = await axios.post(`/salidas/${solicitud.value.id}/despachar`);
      Swal.fire('Éxito', response.data.message, 'success');
      fetchSolicitud(); // Recargar los datos
    }
  } catch (error) {
    let errorMessage = error.response?.data?.message || 'Error al despachar';
    if (error.response?.data?.stock_disponible !== undefined) {
      errorMessage += `. Stock disponible: ${error.response.data.stock_disponible}`;
    }
    Swal.fire('Error', errorMessage, 'error');
  }
};

const solicitar = async () => {
  try {
    const { isConfirmed } = await Swal.fire({
      title: 'Confirmar Solicitud',
      text: '¿Está seguro de enviar esta solicitud?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, solicitar',
      cancelButtonText: 'Cancelar'
    });

    if (isConfirmed) {
      const response = await axios.post(`/salidas/${solicitud.value.id}/solicitar`);
      Swal.fire('Éxito', response.data.message, 'success');
      fetchSolicitud(); // Recargar los datos
    }
  } catch (error) {
    let errorMessage = error.response?.data?.message || 'Error al solicitar';
    if (error.response?.data?.stock_disponible !== undefined) {
      errorMessage += `. Stock disponible: ${error.response.data.stock_disponible}`;
    }
    Swal.fire('Error', errorMessage, 'error');
  }
};

const generateActaSalida = async () => {
  try {
    const response = await axios.get(`/salidas/${solicitud.value.id}/nota-salida`, {
        responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'nota-solicitud.pdf';
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
      console.error('Error al generar PDF:', error);
  }
};

const generateNotaPDF = async () => {
  try {
    const response = await axios.get(`/salidas/${solicitud.value.id}/nota-solicitud`, {
        responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'nota-solicitud.pdf';
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
      console.error('Error al generar PDF:', error);
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('es-BO', options);
};

const getBadgeVariant = (estado) => {
  const variants = {
    pendiente: 'warning',
    aprobada: 'success',
    rechazada: 'danger',
    completada: 'primary',
    solicitada: 'info'
  };
  return variants[estado] || 'secondary';
};

// Inicialización
onMounted(() => {
  fetchSolicitud();
  fetchCategorias();
  fetchItemsDisponibles();
});
</script>

<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
}
.table-responsive {
  max-height: 500px;
  overflow-y: auto;
}
thead th {
  background-color: #D84315;
  color:#ffffff;
  position: sticky;
  top: 0;
}
.partida-badge {
  font-size: 0.7em;
  vertical-align: super;
  margin-left: 5px;
}

.table-fixed-layout {
  table-layout: fixed;
}

.table-fixed-layout tbody{
  table-layout: fixed;
  height: 400px;
}

.table-fixed-layout th:nth-child(1),
.table-fixed-layout td:nth-child(1) {
  width: 25%;
  vertical-align: top;
}

.table-fixed-layout th:nth-child(2),
.table-fixed-layout td:nth-child(2) {
  width: 10%;
  vertical-align: top;
}

.table-fixed-layout th:nth-child(3),
.table-fixed-layout td:nth-child(3) {
  width: 10%;
  vertical-align: top;
}

.table-fixed-layout th:nth-child(4),
.table-fixed-layout td:nth-child(4) {
  width: 10%;
  vertical-align: top;
}

/* Columnas para partida 25600 */
.table-fixed-layout th:nth-child(5),
.table-fixed-layout td:nth-child(5) {
  width: 10%;
  vertical-align: top;
}

.table-fixed-layout th:nth-child(6),
.table-fixed-layout td:nth-child(6) {
  width: 10%;
  vertical-align: top;
}

.table-fixed-layout th:nth-child(7),
.table-fixed-layout td:nth-child(7) {
  width: 10%;
  vertical-align: top;
}

.table-fixed-layout th:nth-child(8),
.table-fixed-layout td:nth-child(8) {
  width: 15%;
  vertical-align: top;
}

/* ==================== ESTILOS MEJORADOS PARA EL AUTOCOMPLETE ==================== */
.suggestions-list {
  position: absolute;
  z-index: 9999;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-top: 2px;
}

.suggestion-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s;
  font-size: 13px;
}

.suggestion-item:hover,
.suggestion-item.active {
  background-color: #e7f1ff;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item .badge {
  font-size: 0.7rem;
}

/* Scroll personalizado para las sugerencias */
.suggestions-list::-webkit-scrollbar {
  width: 6px;
}

.suggestions-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.suggestions-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.suggestions-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Asegurar que el contenedor tenga espacio para las sugerencias */
.position-relative {
  position: relative;
  min-height: 38px;
}

/* Estilo para el input con icono */
.position-relative .fa-search {
  pointer-events: none;
}
</style>
